import BackendService from '../services/backendService';
import { NewPresentationMetadata } from '../services/backendService/types';

export const createBlankPresentation = async (
  metadata?: NewPresentationMetadata,
  maxRetries = 3,
): Promise<{ id: string; livePresentationId: string } | null> => {
  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      return await BackendService.instance.presentations.newPresentationId(metadata);
    } catch {
      if (attempt === maxRetries) return null;
      await new Promise(resolve => setTimeout(resolve, 500 * attempt));
    }
  }
  return null;
};

export const formatPin = (pin?: string | null): string => {
  if (!pin) return '';
  const middle = Math.floor(pin.length / 2);
  return `${pin.slice(0, middle)} ${pin.slice(middle)}`;
};
